import React, { useState, useEffect, useContext } from 'react'
import { MultiSelect } from 'components/MultiSelect'
import { group } from 'd3-array'
import csvjson from 'csvjson'
import LocalesContext from 'components/_locales/localeContext'
import { NameTable } from 'components/NameTable'

import './styles.scss'

type namedataElement = {
  anzahl: string
  geschlecht: 'w' | 'm'
  ortbez18: string
  plz: string
  rang: string
  vorname: string
}

type plzElement = { name: string; plz: number }
interface Props {}
const replaceAll = (str: string, find: string, replace: string) =>
  str.replace(new RegExp(find, 'g'), replace)
export const PLZ_Table = ({}: Props) => {
  const [selectedplz, setPLZ] = useState<
    { name: string; plz: number } | undefined
  >()
  const [namedata, setNamedata] = useState<namedataElement[] | undefined>()
  const [plzlist, setPlzlist] = useState<plzElement[] | undefined>()
  const [tableData, setTableData] = useState<
    [womenMenDataElement[], womenMenDataElement[]]
  >([])
  const __l: localesInterface = useContext<localesInterface>(LocalesContext)

  useEffect(() => {
    let urls = ['_data/plzlist.csv', '_data/vornamenplz.csv']

    Promise.all(urls.map(url => fetch(url)))
      .then(resp => Promise.all(resp.map(r => r.text())))
      .then(result => {
        let plzlist: plzElement[] = csvjson.toObject(result[0], {}).map(m => {
          return { name: m.name, plz: +m.plz }
        })
        setPlzlist(plzlist)
        let namedata = csvjson
          .toObject(result[1], {})
          .filter(f => f.name !== 'n/a')
        setNamedata(namedata)

        setPLZ(plzlist.find(f => f.plz === 9050))
      })
  }, [])

  useEffect(() => {
    if (!namedata || !selectedplz) return

    let filtered = namedata.filter(f => +f.plz === selectedplz.plz)

    let filtered2 = Array.from(
      group(
        filtered,
        d => d.geschlecht,
        d => d.rang
      )
    )
    const reducer = (
      acc: [string, number, number][],
      cur: [string, number, number][]
    ) => {
      let names: string[] = []
      cur.forEach((c: [string, number, number]) => names.push(c[0]))
      acc.push([names.join(', '), cur[0][1], cur[0][2]])
      return acc
    }
    let male = Array.from(
      filtered2[0][0] === 'm' ? filtered2[0][1] : filtered2[1][1]
    )
      .sort((a, b) => +a[0] - +b[0])
      .map(m =>
        m[1].map(d => [
          d.vorname === 'n/a' ? '?' : d.vorname,
          +d.anzahl,
          +d.rang
        ])
      )
      .reduce(reducer, [])

    let female = Array.from(
      filtered2[0][0] === 'w' ? filtered2[0][1] : filtered2[1][1]
    )
      .sort((a, b) => +a[0] - +b[0])
      .map(m =>
        m[1].map(d => [
          d.vorname === 'n/a' ? '?' : d.vorname,
          +d.anzahl,
          +d.rang
        ])
      )
      .reduce(reducer, [])

    setTableData([female, male])
  }, [selectedplz, namedata, plzlist])
  const handleSelect = (plzel: { plz: number; name: string }) => {
    if (plzel) setPLZ(plzel)
  }
  if (!selectedplz || !plzlist || !namedata || !selectedplz.name) return null
  return (
    <div className='PLZ_Table'>
      <div className='ui text container titleholder'>
        <div className='title'>Die häufigsten Vornamen nach Postleitzahl</div>
      </div>
      <div className='ui text container'>
        {plzlist && selectedplz && (
          <>
            <MultiSelect
              data={plzlist}
              label='Postleitzahl oder Gemeinde suchen'
              selected={handleSelect}
              formatOption={d => d.plz + ' - ' + replaceAll(d.name, '/', ', ')}
              placeholder={'Suchen'}
              filterFields={d => d.name + ',' + d.plz}
            />
          </>
        )}
      </div>

      {tableData.length === 2 && (
        <NameTable
          data={tableData}
          title={selectedplz.plz.toString()}
          sub={replaceAll(selectedplz.name, '/', ', ')}
          formatName={d => {
            return d[0] === '?' ? (
              <span className='anonym'>anonymisiert</span>
            ) : (
              d[0]
            )
          }}
        />
      )}
    </div>
  )
}
